import { Middleware } from 'redux'
import { melodyRequest, publicRequest } from './request'
import MelodyMailings from './mailings'
import MelodyEmails from './emails'
import MelodyEmailTemplates from './email_templates'
import MelodyPeople from './people'
import MelodyUser from './user'
import MelodyStats from './stats'
import MelodyReminders from './reminders'
import MelodyCustomFields from './custom_fields'
import MelodyRequiredFields from './required_fieds'
import Notes from './notes'
import Opportunities from './opportunities'
import Cadences from './cadences'
import Tags from './tags'
import Activities from './activities'
import Actions from './actions'
import CrmSyncSettings from './crm_sync_settings'
import TeamEmailSettings from './team_email_settings'
import PublicTeamEmailSettings from './public_team_email_settings'
import TeamPrivacySettings from './team_privacy_settings'
import Accounts from './accounts'
import AccountStages from './accountStages'
import Company from './company'
import Groups from './groups'
import Templates from './templates'

import Snippets from './snippets'
import CrmReferences from './crm_references'

import Meetings from './meetings'
import Sentiments from './sentiments'
import EmailReplies from './email_replies'
import CalendarLofting from './loft_calendar_events'
import Me from './me'
import PublicPeople from './public_people'
import PausePeople from './pause_people'
import Crm from './crm'

import ActivityHistories from './activityHistories'
import Stakeholders from './stakeholders'
import FieldsOrders from './fields_orders'

import LogCall from './log_call'
import CreateLogCall from './create_call_log'
import CreateTask from './create_task'
import Deals from './deals'
import OpportunityFields from './opportunityFields'
import Search from './search'
import PublicCompany from './public_company'
import FrontendInstallations from './frontend_installations'
import IntegrationIframeToken from './integration_iframe_token'

export const SIMPLE_EMAIL_REGEX = /.+@.+\..+/

export class Gateway {
  appUrl?: string
  portalUrl?: string

  user = new MelodyUser(melodyRequest)
  stats = new MelodyStats(melodyRequest)
  mailings = new MelodyMailings(melodyRequest)
  emails = new MelodyEmails(melodyRequest)
  emailTemplates = new MelodyEmailTemplates(melodyRequest)
  people = new MelodyPeople(melodyRequest)
  reminders = new MelodyReminders(melodyRequest)
  customFields = new MelodyCustomFields(melodyRequest)
  requiredFields = new MelodyRequiredFields(melodyRequest)
  cadences = new Cadences(melodyRequest)
  actions = new Actions(melodyRequest)
  notes = new Notes(melodyRequest)
  tags = new Tags(melodyRequest)
  activities = new Activities(melodyRequest)
  teamEmailSettings = new TeamEmailSettings(melodyRequest)
  crmSyncSettings = new CrmSyncSettings(melodyRequest)
  accounts = new Accounts(melodyRequest)
  accountStages = new AccountStages(publicRequest)
  groups = new Groups(melodyRequest)
  templates = new Templates(publicRequest)
  company = new Company(melodyRequest)
  publicCompany = new PublicCompany(publicRequest)

  snippets = new Snippets(publicRequest)
  crmReferences = new CrmReferences(publicRequest)

  meetings = new Meetings(publicRequest)
  sentiments = new Sentiments(melodyRequest)
  emailReplies = new EmailReplies(publicRequest)
  me = new Me(publicRequest)
  calendarLofting = new CalendarLofting(publicRequest)
  publicPeople = new PublicPeople(publicRequest)
  crm = new Crm(publicRequest)

  publicTeamEmailSettings = new PublicTeamEmailSettings(publicRequest)
  teamPrivacySettings = new TeamPrivacySettings(publicRequest)

  activityHistories = new ActivityHistories(publicRequest)
  stakeholders = new Stakeholders(publicRequest)
  fieldsOrders = new FieldsOrders(melodyRequest)

  logCall = new LogCall(melodyRequest)
  createLogCall = new CreateLogCall(publicRequest)
  createTask = new CreateTask(publicRequest)
  deals = new Deals(publicRequest)
  opportunities = new Opportunities(publicRequest)
  opportunityFields = new OpportunityFields(publicRequest)
  pausePeople = new PausePeople(publicRequest)
  search = new Search(publicRequest)
  frontendInstallations = new FrontendInstallations(publicRequest)
  integrationIframeToken = new IntegrationIframeToken(melodyRequest)

  watchToken: Middleware = () => next => action => {
    if (action !== undefined && action.type === 'SET_USER_SESSION') {
      melodyRequest.setBaseUrl(action.auth.environment.melody_api_url)
      publicRequest.setBaseUrl(action.auth.environment.public_api_url)
      this.appUrl = action.auth.environment.app_url
      this.portalUrl = action.auth.environment.portal_url
    }
    return next(action)
  }
}

export default new Gateway()
